module.exports = __webpack_public_path__ + "static/media/cloudy-day-2.b931d84d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-day-2.svg
// module id = 511
// module chunks = 0